import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberListComponent } from './member-list/member-list.component';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MemberFormComponent } from './member-form/member-form.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { AppRoutingModule } from '../app-routing.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DirectsModule } from '../directs/directs.module';
import { SharedModule } from '../shared/shared.module';
import { MemberViewComponent } from './member-view/member-view.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MembersFileSendComponent } from './members-file-send/members-file-send.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MaterialModule } from '../material/material.module';
import { ComponentsModule } from '../components/components.module';
import { MemberCardComponent } from './member-card/member-card.component';
import { MembersGetFile } from './get-file/members-file-send.component';

@NgModule({
  declarations: [
    MemberListComponent,
    MemberFormComponent,
    MemberViewComponent,
    MembersFileSendComponent,
    MembersGetFile,
    MemberCardComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatTooltipModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatDialogModule,
    AppRoutingModule,
    MatPaginatorModule,
    DirectsModule,
    SharedModule,
    ImageCropperModule,
    ScrollingModule,
    MaterialModule,
    ComponentsModule,
  ],
  exports: [MemberCardComponent]
})
export class MembersModule {}
